export default {
  array: {
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: '10px'
  }
};
